// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles-module--iconWrapper--2AI4z","img":"styles-module--img--3Fva6"};